import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'authentication/services/authentication.service';
import { StorageService } from '../services';
import { PASSWORD_CHANGE_EMAIL, PASSWORD_CHANGE_TOKEN } from '../constants/general-constants';

@Injectable()
export class RequirePasswordChangeGuard implements CanActivate {
    constructor(
        private router: Router,
        private storageService: StorageService,
        private authService: AuthenticationService,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.authService.isLoggedIn()) {
            if (state.url.includes('change-password')) {
                if (
                    this.authService.isUserLoggedInRequestedPasswordChange() ||
                    (this.storageService.getFromSession(PASSWORD_CHANGE_EMAIL) && this.storageService.getFromSession(PASSWORD_CHANGE_TOKEN))
                ) {
                    return true;
                } else {
                    this.router.navigate(['/login']);
                    return false;
                }
            } else {
                return true;
            }
        } else {
            if (state.url.includes('change-password')) {
                this.router.navigate(['/dashboard']);
                return false;
            } else {
                return true;
            }
        }
    }
}
